import React from 'react';
import HomeGivesBack from './HomeGivesBack';
import HomeFI from './HomeFI';
import MainLayout from '../../layouts/MainLayout';

export default function Home() {
  return (
    <MainLayout>
      <HomeFI />
      <HomeGivesBack />
    </MainLayout>
  );
}
